const config = {
  apiUrl: 'https://dev.darum.ng/',
  dashboardUrl: 'https://ccl-cd.web.app/',
  callbackUrlBase: 'https://ccl-lp.web.app/',
};

export default config;
